import { IProduct } from '@kizi/comparator-core';
import React, { MouseEventHandler } from 'react';
import { ProductNewProps } from '../../..';
import RatesComp from '../../../../Product/ExpandedPart/Rates';
import { TariffsTabHome } from './Home';

export interface TariffsTabProps {
  data: IProduct;
  onButtonClick: MouseEventHandler<Element>;
  priceMode: ProductNewProps['priceMode'];
}

export const TariffsTab: React.FC<TariffsTabProps> = (props) => {
  const { data, onButtonClick } = props;

  const { price, type } = data;

  let render = <></>;

  if (type.includes('energy')) {
    render = (
      <RatesComp data={data} type={type} price={price} onButtonInfoClick={onButtonClick} />
    );
  }

  if (type === 'home') {
    render = <TariffsTabHome {...props} />;
  }

  return render;
};
